import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './servicing-common.actions';
import { ServicingCommonState } from './servicing-common.state';

/**
 * servicingCommon initial state
 */
export const servicingCommonInitialState: ServicingCommonState = {
  model: null,
};

/**
 * List of basic actions for ServicingCommon Store
 */
export const servicingCommonReducerFeatures: ReducerTypes<ServicingCommonState, ActionCreator[]>[] = [
  on(actions.setServicingCommon, (_state, payload) => ({ ...payload })),

  on(actions.updateServicingCommon, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetServicingCommon, () => servicingCommonInitialState),
];

/**
 * ServicingCommon Store reducer
 */
export const servicingCommonReducer = createReducer(servicingCommonInitialState, ...servicingCommonReducerFeatures);
